    import axiosAuth from '../../../shared/configs/axios-auth'

    const getDefaultState = () => {
        return {
            extrasTemplates: [],
        }
    }
    
    const state = getDefaultState()

    const getters = {
        extrasTemplates: state => {
            return state.extrasTemplates
        },
    }

    const mutations = {
        resetState (state) {
            Object.assign(state, getDefaultState())
        },
        extrasTemplates: (state, payload) => {
            state.extrasTemplates = payload
        },
    }

    const actions = {
       
        getExtrasTemplates: ({commit}) =>{
            commit('updating', true)
            axiosAuth.get('/extrasTemplates')
            .then(
                res => {
                    commit('updating', false)
                    if(!res.data.message){
                        commit('extrasTemplates', res.data)
                    }

                }
              )
              .catch(
                error => {
                  console.log(error.response)
                  commit('updating', false)
                }
              )
        },

        postExtraTemplate ({commit, dispatch}, payload) {
            commit('updating', true)
            axiosAuth.post('/extrasTemplates', payload)
                .then(
                    res => {
                        commit('trash', res)
                        commit('updating', false)
                        dispatch('getExtrasTemplates')
                    }
                )
                .catch(
                error => {
                    console.log(error.response)
                    commit('updating', false)
                }
                )
        },

        updateExtrasTemplate: ({commit, dispatch}, payload) => {
            console.log('payload:', payload)
            
            commit('updating', true)
            axiosAuth.patch('/extrasTemplates/'+ payload._id, payload.data)
            .then(
                res => {
                    commit('trash', res)
                    commit('updating', false)
                    dispatch('getMenus')
                }
              )
            .catch(
                error => {
                    console.log(error.response)
                    commit('updating', false)
                }
            ) 
        },

        deleteExtrasTemplate: ({commit, dispatch}, payload) => {
            commit('updating', true)
            axiosAuth.delete('/extrasTemplates/'+ payload._id)
            .then(
                () => {
                    dispatch('getExtrasTemplates')
                }
              )
            .catch(
                error => {
  
                    console.log(error.response)
                    commit('updating', false)
                }
            ) 
        },
    }

    export default {
        state,
        getters,
        mutations,
        actions
    }